import { render } from "./issue_drugs.vue?vue&type=template&id=ae0e3c0c&scoped=true"
import script from "./issue_drugs.vue?vue&type=script&lang=js"
export * from "./issue_drugs.vue?vue&type=script&lang=js"

import "./issue_drugs.vue?vue&type=style&index=0&id=ae0e3c0c&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae0e3c0c"]])

export default __exports__